export enum LOS {
    ENCOMPASS = 'ENCOMPASS',
    MCP = 'MCP'
}

export const losDisplay = {
    [LOS.ENCOMPASS]: 'Encompass',
    [LOS.MCP]: 'MCP'
};
